<template>
  <dialog-base>
    <div :class="`step-${step}`"
         class="mod-guide">
      <div class="tip">
        {{textMap[step]}}
      </div>
      <div class="box-mid">
        <div class="ico-person"></div>
        <div v-if="step === 1"
             class="ico-gift">
          <div class="text">
            “宝物”一览
          </div>
          <div class="ico-chest-set">
          </div>
        </div>
      </div>
      <div class="btn-red"
           @click="next">
        {{btnTextMap[step]}}
      </div>
    </div>
  </dialog-base>
</template>

<script>
import DialogBase from '../base'
import mixin from '../mixin'
export default {
  mixins: [mixin],
  data() {
    return {
      step: 0,
      textMap: [
        'Hi，我是小安，欢迎来到小安城市寻宝记，你的任务是找到我和宝物，准备好挑战了吗？',
        '来看看宝物的样子吧！寻找宝物数量达到10/15/20个可分别获得一次抽奖机会，最多3次抽奖机会，至高抽取88元红包，奖品可累计获得，祝你好运！'
      ],
      btnTextMap: [
        '准备好了',
        '记住了'
      ]
    }
  },
  components: {
    DialogBase
  },
  methods: {
    next() {
      if (this.step === 1) {
        this.close()
        this.onOk && this.onOk()
        return
      }
      this.step++
    }
  }
}
</script>

<style lang="scss" scoped>
.mod-guide {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  height: 1122px;
  .tip {
    margin-bottom: 41px;
    position: relative;
    padding: 30px 40px;
    width: 668px;
    background: #fdf2e5;
    border: 4px solid #882104;
    border-radius: 10px;
    font-size: 34px;
    font-weight: bold;
    color: #882104;
    opacity: 0.9;
    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 190px;
      transform: translateY(50%) rotate(45deg);
      border: 14px solid;
      border-color: transparent #fdf2e5 #fdf2e5 transparent;
      box-shadow: 4px 4px 0 0 #882104;
      z-index: 10;
    }
  }
  .box-mid {
    display: flex;
    align-items: center;
    justify-content: center;
    .ico-person {
      margin-left: -200px;
      margin-bottom: 81px;
      width: 181px;
      height: 424px;
      background-image: url("~@/assets/ico/ico-person.png");
      background-size: 100% auto;
      background-repeat: no-repeat;
    }
    .ico-gift {
      margin-left: 68px;
      transform: translateY(-30px);
      width: 296px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .text {
        font-size: 36px;
        font-weight: bold;
        color: #f25560;
      }
      .ico-chest-set {
        margin-top: 30px;
        width: 296px;
        height: 352px;
        background-image: url("../../../assets/ico/ico-chest-set.png");
        background-size: 100% auto;
        background-repeat: no-repeat;
      }
    }
  }
  &.step-1 {
    .box-mid {
      .ico-person {
        margin-left: 80px;
      }
    }
  }
  .btn-red {
    padding-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 479px;
    height: 95px;
    background-image: url("~@/assets/ico/btn-red.png");
    background-size: 100% auto;
    background-repeat: no-repeat;
    color: #ffffff;
    text-shadow: #872c0c 2px 0 2px, #872c0c 0 2px 2px, #872c0c -2px 0 2px,
      #872c0c 0 -2px 2px;
  }
}
</style>